export default __webpack_public_path__ + "static/media/profile.5ba3cadb.jpg";